<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 40vw">
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title">
          {{ isEdit ? "Update Nurse Note" : "Add Nurse Note" }}
        </h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <form @submit.prevent="saveNote">
          <div class="row mb-3">
            <div class="col-md-6">
              <label>Date & Time:</label>
              <input
                type="datetime-local"
                v-model="form.note_date"
                class="form-control"
                required
              />
            </div>
            <div class="col-md-6">
              <label>Author (Nurse):</label>
              <input
                type="text"
                v-model="form.nurse_name"
                class="form-control"
                placeholder="Enter nurse name"
                required
              />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-md-12">
              <label>Note:</label>
              <textarea
                v-model="form.note_text"
                class="form-control"
                rows="4"
                placeholder="Write nurse note..."
                required
              ></textarea>
            </div>
          </div>
        </form>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="closeModal">
          Close
        </button>
        <button type="button" class="btn btn-primary" @click="saveNote">
          {{ isEdit ? "Update" : "Save" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
export default {
  name: "NurseNotesModal",
  props: {
    note: {
      type: Object,
      default: null,
    },
    visit_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      form: {
        note_date: "",
        nurse_name: "",
        note_text: "",
        visit_id: this.visit_id,
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.note;
    },
  },
  mounted() {
    if (this.note) {
      this.form = { ...this.note };
    } else {
      // Default to current datetime
      this.form.note_date = new Date().toISOString().slice(0, 16);
    }
  },
  methods: {
    closeModal() {
      this.$emit("close-nurse-notes-modal");
    },
    async saveNote() {
      const url = "nurse-notes";
      const body = this.form;
      // console.log(body);
      const resp = await generalApiRequest(url, "POST", body, 1);
      console.log(resp);
      this.closeModal();
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.mmodal-content {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 1rem;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-footer {
  border-top: 1px solid #ddd;
  justify-content: flex-end;
}

.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
</style>
